import script from "./CalendarDay.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarDay.vue?vue&type=script&setup=true&lang=ts"

import "./CalendarDay.vue?vue&type=style&index=0&id=63258dc2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63258dc2"]])

export default __exports__